"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var workflow_designer_viewport_model_1 = require("../shared/workflow-designer-viewport.model");
var workflow_designer_state_model_1 = require("../shared/workflow-designer-state.model");
var workflow_designer_action_model_1 = require("../shared/workflow-designer-action.model");
var idm_workflow_service_client_js_1 = require("@synisys/idm-workflow-service-client-js");
var material_1 = require("@angular/material");
var Observable_1 = require("rxjs/Observable");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var router_1 = require("@angular/router");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var subscription_manager_decorator_1 = require("../shared/subscription-manager.decorator");
var workflow_designer_types_1 = require("../shared/workflow-designer.types");
var confirm_popup_component_1 = require("../confirm-popup/confirm-popup.component");
var process_structure_dto_1 = require("@synisys/idm-workflow-service-client-js/api/model/process-structure.dto");
var action_indexed_dto_1 = require("@synisys/idm-workflow-service-client-js/api/model/action-indexed.dto");
var services_1 = require("../services");
var WorkflowDesignerComponent = /** @class */ (function () {
    function WorkflowDesignerComponent(processService, messageService, languageService, currentLanguageProvider, formManagementService, popUpsService, dialog, router, route, cdRef) {
        this.processService = processService;
        this.messageService = messageService;
        this.languageService = languageService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.formManagementService = formManagementService;
        this.popUpsService = popUpsService;
        this.dialog = dialog;
        this.router = router;
        this.route = route;
        this.cdRef = cdRef;
        this.viewMode = false;
        this.processId = null;
        this.showDrawerForm = false;
        this.viewport = new workflow_designer_viewport_model_1.WorkflowDesignerViewportModel();
        this.ready = false;
        this.editState = null;
        this.editAction = null;
        this.editStateError = null;
        this.editActionError = null;
        this.pleaseSelect = '...';
        this._editStateInstance = null;
        this._editActionInstance = null;
        this.initialized = false;
    }
    Object.defineProperty(WorkflowDesignerComponent.prototype, "editStateInstance", {
        get: function () {
            return this._editStateInstance;
        },
        set: function (state) {
            this._editStateInstance = state;
            this._editActionInstance = null;
            this.editStateError = null;
            if (state) {
                this.drawer.open();
            }
            else {
                this.drawer.close();
            }
            this.afterFormOpened();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerComponent.prototype, "editActionInstance", {
        get: function () {
            return this._editActionInstance;
        },
        set: function (action) {
            this._editStateInstance = null;
            this._editActionInstance = action;
            this.editActionError = null;
            if (action) {
                this.drawer.open();
            }
            else {
                this.drawer.close();
            }
            this.afterFormOpened();
        },
        enumerable: true,
        configurable: true
    });
    WorkflowDesignerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.viewport.viewMode = this.viewMode;
        this.processId = this.route.snapshot.paramMap.get('processId') || this.route.data['processId'];
        this.$sm = Observable_1.Observable.zip(this.languageService.getAvailableLanguages(), this.currentLanguageProvider.getCurrentLanguage(), this.getMessage('workflow_designer.please_select')).subscribe(function (res) {
            _this.languages = res[0];
            _this.currentLanguageId = res[1].getId();
            _this.pleaseSelect = res[2];
            _this.loadLayout();
        });
    };
    WorkflowDesignerComponent.prototype.ngAfterViewInit = function () {
        this.initialized = true;
        this.cdRef.detectChanges();
    };
    WorkflowDesignerComponent.prototype.editItem = function (item) {
        switch (item && item.type) {
            case workflow_designer_types_1.WorkflowDesignerType.STATE:
                this.editState = item;
                this.editStateInstance = new workflow_designer_state_model_1.WorkflowDesignerStateModel(null, item.name, item.description).setEdit().setIsFinal(item.isFinal);
                break;
            case workflow_designer_types_1.WorkflowDesignerType.START:
                this.editState = null;
                this.editStateInstance = null;
                break;
            case workflow_designer_types_1.WorkflowDesignerType.ACTION:
                this.editAction = item;
                this.editActionInstance = new workflow_designer_action_model_1.WorkflowDesignerActionModel(null, item.name, item.description).setEdit().linkStates(item.begin, item.end).setFormId(item.formId);
                break;
            case workflow_designer_types_1.WorkflowDesignerType.ACTION_START:
                this.editAction = null;
                this.editActionInstance = null;
                break;
            case workflow_designer_types_1.WorkflowDesignerType.POINT:
                if (item.attr.transitionFrom && item.attr.nearest) {
                    if (item.attr.transitionFrom !== this.viewport.process.states[item.attr.nearest.stateIndex] || item.attr.transitionFromOrigin !== item.attr.nearest.matrixIndex) {
                        this.editActionInstance = new workflow_designer_action_model_1.WorkflowDesignerActionModel()
                            .linkStates(item.attr.transitionFrom, this.viewport.process.states[item.attr.nearest.stateIndex])
                            .setOrigins(item.attr.transitionFromOrigin, item.attr.nearest.matrixIndex);
                        this.viewport.gizmo.show();
                    }
                }
                else if (item.attr.transitionFrom) {
                    this.editStateInstance = new workflow_designer_state_model_1.WorkflowDesignerStateModel().position(this.viewport.gizmo.end.x - 100, this.viewport.gizmo.end.y - 21);
                    this.editStateInstance.createState.transitionFrom = item.attr.transitionFrom;
                    this.editStateInstance.createState.transitionFromOrigin = item.attr.transitionFromOrigin;
                    this.viewport.gizmo.show();
                }
                break;
            default:
                this.editState = null;
                this.editStateInstance = null;
                this.editAction = null;
                this.editActionInstance = null;
                break;
        }
    };
    WorkflowDesignerComponent.prototype.openStateDrawer = function () {
        var state = new workflow_designer_state_model_1.WorkflowDesignerStateModel();
        this.editStateInstance = state;
    };
    WorkflowDesignerComponent.prototype.openActionDrawer = function () {
        var action = new workflow_designer_action_model_1.WorkflowDesignerActionModel();
        this.editActionInstance = action;
    };
    WorkflowDesignerComponent.prototype.deleteState = function (confirmed) {
        var _this = this;
        if (confirmed === void 0) { confirmed = false; }
        if (!confirmed) {
            this.$sm.deleteStatePopup = this.deletePopup().subscribe(function (answer) {
                if (answer) {
                    _this.deleteState(true);
                }
            });
            return;
        }
        var index = this.viewport.process.states.indexOf(this.editState);
        if (index !== -1) {
            this.viewport.process.actions = this.viewport.process.actions.filter(function (action) {
                return !(action.begin === _this.editState || action.end === _this.editState);
            });
            this.viewport.process.states.splice(index, 1);
            this.linkStates();
        }
        this.editStateInstance = null;
        this.viewport.selected = null;
    };
    WorkflowDesignerComponent.prototype.linkStates = function () {
        if (this.viewport.process.states.length === 2) {
            this.viewport.process.actions.length = 0;
            this.viewport.process.actions.push(new workflow_designer_action_model_1.WorkflowDesignerActionModel(0).linkStates(this.viewport.process.states[0], this.viewport.process.states[1]).setStart());
        }
        else if (this.editStateInstance.createState.transitionFrom) {
            this.editActionInstance = new workflow_designer_action_model_1.WorkflowDesignerActionModel()
                .linkStates(this.editStateInstance.createState.transitionFrom, this.editStateInstance)
                .setOrigins(this.editStateInstance.createState.transitionFromOrigin, null);
            return;
        }
    };
    WorkflowDesignerComponent.prototype.addState = function () {
        this.editStateError = this.editStateValidationError();
        if (this.editStateError) {
            return;
        }
        this.editStateInstance.position(this.editStateInstance.x || this.viewport.centerX - 100, this.editStateInstance.y || this.viewport.centerY - 50);
        this.viewport.process.states.push(this.editStateInstance);
        //this.viewport.selected = this.editStateInstance;
        this.linkStates();
        this.editStateInstance = null;
    };
    WorkflowDesignerComponent.prototype.updateState = function () {
        this.editStateError = this.editStateValidationError();
        if (this.editStateError) {
            return;
        }
        this.editState.name = this.editStateInstance.name;
        this.editState.description = this.editStateInstance.description;
        this.editState.isFinal = this.editStateInstance.isFinal;
        this.editStateInstance = null;
    };
    WorkflowDesignerComponent.prototype.deleteAction = function (confirmed) {
        var _this = this;
        if (confirmed === void 0) { confirmed = false; }
        if (!confirmed) {
            this.$sm.deleteActionPopup = this.deletePopup().subscribe(function (answer) {
                if (answer) {
                    _this.deleteAction(true);
                }
            });
            return;
        }
        var index = this.viewport.process.actions.indexOf(this.editAction);
        if (index !== -1) {
            this.viewport.process.actions.splice(index, 1);
        }
        this.editActionInstance = null;
        this.viewport.selected = null;
    };
    WorkflowDesignerComponent.prototype.addAction = function () {
        this.editActionError = this.editActionValidationError();
        if (this.editActionError) {
            return;
        }
        this.viewport.process.actions.push(this.editActionInstance);
        this.viewport.selected = this.editActionInstance;
        this.editActionInstance = null;
        this.cdRef.detectChanges();
    };
    WorkflowDesignerComponent.prototype.updateAction = function () {
        this.editActionError = this.editActionValidationError();
        if (this.editActionError) {
            return;
        }
        this.editAction.name = this.editActionInstance.name;
        this.editAction.description = this.editActionInstance.description;
        this.editAction.begin = this.editActionInstance.begin;
        this.editAction.end = this.editActionInstance.end;
        this.editAction.formId = this.editActionInstance.formId;
        this.editStateInstance = null;
    };
    WorkflowDesignerComponent.prototype.drawerClosed = function () {
        this._editStateInstance = null;
        this._editActionInstance = null;
        this.editState = null;
        this.editAction = null;
    };
    WorkflowDesignerComponent.prototype.drawerCloseStart = function () {
        this.viewport.gizmo.hide();
    };
    WorkflowDesignerComponent.prototype.renderMetadata = function () {
        console.log(JSON.stringify(this.viewport.getMetadata(), null, '    '));
    };
    WorkflowDesignerComponent.prototype.deletePopup = function (message) {
        if (message === void 0) { message = 'workflow_designer.remove_selected_process'; }
        var dialogConfig = new material_1.MatDialogConfig();
        dialogConfig.width = '450px';
        dialogConfig.data = {
            message: message
        };
        dialogConfig.id = 'confirm-popup-id';
        var dialogRef = this.dialog.open(confirm_popup_component_1.ConfirmPopup, dialogConfig);
        return this.$sm.deleteProcessConfirmation = dialogRef.afterClosed();
    };
    WorkflowDesignerComponent.prototype.editStateValidationError = function () {
        if (!this.multilingualStringValid(this.editStateInstance.name)) {
            return 'name';
        }
        return null;
    };
    WorkflowDesignerComponent.prototype.editActionValidationError = function () {
        if (!this.multilingualStringValid(this.editActionInstance.name)) {
            return 'name';
        }
        if (!this.editActionInstance.begin) {
            return 'begin';
        }
        if (!this.editActionInstance.end) {
            return 'end';
        }
        return null;
    };
    WorkflowDesignerComponent.prototype.getMessage = function (key) {
        return this.messageService.getMessage(key);
    };
    WorkflowDesignerComponent.prototype.loadLayout = function () {
        var _this = this;
        this.processService.getStructure(this.processId).then(function (process) {
            _this.processStructure = process;
            var startState = new workflow_designer_state_model_1.WorkflowDesignerStateModel(0).setStart().position(40, 180, 120, 42);
            _this.viewport.process.states.push(startState);
            process.getStates().forEach(function (state) {
                var viewportState = new workflow_designer_state_model_1.WorkflowDesignerStateModel(state.getId(), state.getName(), state.getDescription()).setIsFinal(state.getIsFinal());
                _this.viewport.process.states.push(viewportState);
            });
            if (process.getInitialStateIndex() !== null && _this.viewport.process.states[process.getInitialStateIndex() + 1]) {
                _this.viewport.process.actions.push(new workflow_designer_action_model_1.WorkflowDesignerActionModel(0).linkStates(_this.viewport.process.states[0], _this.viewport.process.states[process.getInitialStateIndex() + 1]).setStart());
            }
            process.getActions().forEach(function (action) {
                _this.viewport.process.actions.push(new workflow_designer_action_model_1.WorkflowDesignerActionModel(action.getId(), action.getName(), action.getDescription()).linkStates(_this.viewport.process.states[action.getInitialStateIndex() + 1], _this.viewport.process.states[action.getTargetStateIndex() + 1]).setFormId(action.getFormId()));
            });
            _this.viewport.setMetadata(process.getLayout());
            _this.ready = true;
            _this.$sm = _this.formManagementService.loadFormsByCategoryAndType(process.getCategorySystemName(), 2).subscribe(function (forms) {
                _this.actionSubForms = [];
                forms.forEach(function (form) {
                    if (form.entityTypeId === 3) {
                        _this.actionSubForms.push(form);
                    }
                });
            });
        });
    };
    WorkflowDesignerComponent.prototype.cancelSave = function () {
        this.router.navigate(['../'], { relativeTo: this.route });
    };
    WorkflowDesignerComponent.prototype.formCancel = function () {
        this.drawer.close();
        this.viewport.selected = null;
    };
    WorkflowDesignerComponent.prototype.saveLayout = function () {
        var _this = this;
        var statesDto = [];
        var actionsDto = [];
        this.viewport.process.states.forEach(function (state) {
            if (state.type === workflow_designer_types_1.WorkflowDesignerType.STATE) {
                var stateDto = new idm_workflow_service_client_js_1.StateDto(state.id, state.name && state.name.toMap(), state.description && state.description.toMap(), null, state.isFinal);
                statesDto.push(stateDto);
            }
        });
        this.viewport.process.actions.forEach(function (action) {
            if (action.type === workflow_designer_types_1.WorkflowDesignerType.ACTION) {
                var initialStateIndex = _this.viewport.process.states.indexOf(action.begin);
                var targetStateIndex = _this.viewport.process.states.indexOf(action.end);
                var actionDto = new action_indexed_dto_1.ActionIndexedDto(action.id, action.name.toMap(), action.description && action.description.toMap(), null, null, initialStateIndex !== -1 ? initialStateIndex - 1 : null, targetStateIndex !== -1 ? targetStateIndex - 1 : null, action.formId);
                actionsDto.push(actionDto);
            }
        });
        var initialProcessStateIndex = this.viewport.process.states.indexOf(this.viewport.process.actions[0] && this.viewport.process.actions[0].end);
        if (initialProcessStateIndex === -1 && this.viewport.process.states.length > 1) {
            initialProcessStateIndex = 1;
        }
        var processDto = new process_structure_dto_1.ProcessStructureDto(this.processId, this.processStructure.getName().toMap(), null, this.processStructure.getCategorySystemName(), this.processStructure.getModifiedBy(), this.processStructure.getModifiedOn(), statesDto, actionsDto, this.viewport.getMetadata(), initialProcessStateIndex !== -1 ? initialProcessStateIndex - 1 : null);
        this.processService.update(this.processStructure.getId(), processDto).then(function () {
            _this.router.navigate(['../'], { relativeTo: _this.route });
        });
    };
    WorkflowDesignerComponent.prototype.afterFormOpened = function () {
        var _this = this;
        this.showDrawerForm = false;
        setTimeout(function () {
            _this.showDrawerForm = true;
            setTimeout(function () {
                var drawer = _this.drawer;
                var inputs = drawer._elementRef && drawer._elementRef.nativeElement && drawer._elementRef.nativeElement.getElementsByTagName('input');
                if (inputs && inputs.length) {
                    inputs[0].focus();
                }
            }, 400);
        }, 0);
    };
    WorkflowDesignerComponent.prototype.multilingualStringValid = function (name) {
        if (!name || !name.getValue) {
            return false;
        }
        var ret = true;
        this.languages.forEach(function (language) {
            if (!(name.getValue(language.getId()) || '').trim()) {
                ret = false;
            }
        });
        return ret;
    };
    WorkflowDesignerComponent.decorators = [
        { type: core_1.Component, args: [{
                    
                    selector: 'sis-workflow-designer',
                    template: require('./sis-workflow-designer.component.html'),
                    styles: [require('./sis-workflow-designer.component.css')]
                },] },
    ];
    /** @nocollapse */
    WorkflowDesignerComponent.ctorParameters = function () { return [
        { type: idm_workflow_service_client_js_1.ProcessService, },
        { type: idm_message_language_service_client_js_1.MessageService, },
        { type: idm_message_language_service_client_js_1.LanguageService, },
        { type: idm_session_data_provider_api_js_1.CurrentLanguageProvider, },
        { type: services_1.FormManagementService, },
        { type: services_1.PopUpsService, },
        { type: material_1.MatDialog, },
        { type: router_1.Router, },
        { type: router_1.ActivatedRoute, },
        { type: core_1.ChangeDetectorRef, },
    ]; };
    WorkflowDesignerComponent.propDecorators = {
        "viewMode": [{ type: core_1.Input },],
        "processId": [{ type: core_1.Input },],
        "drawer": [{ type: core_1.ViewChild, args: ['drawer',] },],
    };
    WorkflowDesignerComponent = __decorate([
        subscription_manager_decorator_1.SubscriptionManager(),
        __metadata("design:paramtypes", [idm_workflow_service_client_js_1.ProcessService,
            idm_message_language_service_client_js_1.MessageService,
            idm_message_language_service_client_js_1.LanguageService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            services_1.FormManagementService,
            services_1.PopUpsService,
            material_1.MatDialog,
            router_1.Router,
            router_1.ActivatedRoute,
            core_1.ChangeDetectorRef])
    ], WorkflowDesignerComponent);
    return WorkflowDesignerComponent;
}());
exports.WorkflowDesignerComponent = WorkflowDesignerComponent;
//# sourceMappingURL=sis-workflow-designer.component.js.map